import React, { useState, useEffect, useRef } from 'react';
import { io } from 'socket.io-client';
import './MessageInput.css';

const MessageInput = ({ onSubmit, credits = 0, username }) => {
  const [content, setContent] = useState('');
  const typingTimeoutRef = useRef(null);
  const socketRef = useRef(null);
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

  useEffect(() => {
    // Connect to Socket.IO for typing indicators
    if (username) {
      socketRef.current = io(API_URL);
    }
    
    return () => {
      if (socketRef.current) {
        socketRef.current.close();
      }
      if (typingTimeoutRef.current) {
        clearTimeout(typingTimeoutRef.current);
      }
    };
  }, [API_URL, username]);

  const handleChange = (e) => {
    const newContent = e.target.value;
    setContent(newContent);

    // Emit typing indicator with debouncing to prevent flickering
    if (socketRef.current && username && newContent.length > 0) {
      // Clear previous timeout
      if (typingTimeoutRef.current) {
        clearTimeout(typingTimeoutRef.current);
      }
      
      // Emit typing indicator immediately on first keystroke
      socketRef.current.emit('typing', { username, userId: null });
      
      // Set a longer timeout before stopping (4 seconds of inactivity)
      // This prevents flickering when typing with pauses
      typingTimeoutRef.current = setTimeout(() => {
        // Typing stopped - no need to emit, just let it timeout on server
      }, 4000);
    } else if (newContent.length === 0) {
      // Clear timeout if content is empty
      if (typingTimeoutRef.current) {
        clearTimeout(typingTimeoutRef.current);
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (content.trim().length === 0) {
      return;
    }
    if (content.length > 500) {
      alert('Message cannot exceed 500 characters');
      return;
    }
    onSubmit(content.trim());
    setContent('');
    
    // Clear typing timeout on submit
    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="message-input-form">
      <div className="input-container win98-bevel-inset">
        <textarea
          value={content}
          onChange={handleChange}
          placeholder="Type your message here... (1 Credit required to send)"
          className="message-textarea"
          rows="3"
          maxLength={500}
        />
        <div className="char-count">
          {content.length}/500
        </div>
      </div>
      <button
        type="submit"
        className="win98-button send-button"
        disabled={content.trim().length === 0 || credits < 1}
        title={credits < 1 ? 'Insufficient credits. Please deposit more DOGE.' : ''}
      >
        💰 Send Message (1 Credit) {credits < 1 && '⚠️'}
      </button>
    </form>
  );
};

export default MessageInput;

